import { useState, useEffect } from 'react';
import { Button, message, Tag, Table } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Https from '@/https';
import './Device.css';

export default function DeviceDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [detail, setDetail] = useState<any>({});
  const [messageApi, messageContextHolder] = message.useMessage();
  const getDeviceDetail = () => {
    Https.post({
      url: 'Api/device/V1/device/FindDeviceById',
      data: { id: location.state?.deviceId }
    }).then(res => {
      if(res.state) {
        setDetail(res.data);
      } else {
        messageApi.error(res.data.errorMessage ?? res.message ?? '获取设备详情失败');
      }
    }).catch(error => {
      messageApi.error(error);
    })
  }

  const [oprationList, setOprationList] = useState([]);
  const oprationColumns = [
     {
      title: '操作者',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '操作时间',
      dataIndex: 'time',
      key: 'time',
      width: 180
    },
    {
      title: '操作内容',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
    },
  ]

  const back = () => {
    navigate(-1);
    dispatch({
      type: 'POP_MENU_KEYPATH',
      payload: { keyPath: 1, selectedKeys: 1 }
    })
  }

  useEffect(() => {
    getDeviceDetail();
  }, [])

  return (
    <section className="Device-Detail">
      <Button onClick={back} size="small" className="back-btn">返回</Button>
      <section className="detail-title">设备状态</section>
      <section className="detail-info">
        <section className="detail-item">
          <section className="label">所属公司</section>
          <section className="text">{detail.tenantName}</section>
        </section>
        <section className="detail-item">
          <section className="label">设备状态</section>
          <section className="text">
            {
              detail.status === 1 ?
              <Tag color="success">使用中</Tag> :
              detail.status === 2 ?
              <Tag color="error">暂停使用</Tag> :
              <Tag color="warning">预投放</Tag>
            }
          </section>
        </section>
        <section className="detail-item">
          <section className="label">在线状态</section>
          <section className="text">
            {
              detail.isOnline ?
              <Tag color="success">在线</Tag> :
              <Tag color="error">离线</Tag>
            }
          </section>
        </section>
      </section>
      <section className="detail-title">设备基本信息</section>
      <section className="detail-info">
        <section className="detail-item">
          <section className="label">平台唯一码</section>
          <section className="text">{detail.deviceNumber}</section>
        </section>
        <section className="detail-item">
          <section className="label">设备唯一码</section>
          <section className="text">{detail.sn}</section>
        </section>
        <section className="detail-item">
          <section className="label">设备名称</section>
          <section className="text">{detail.name}</section>
        </section>
        <section className="detail-item">
          <section className="label">设备类型</section>
          <section className="text">{detail.typeName}</section>
        </section>
        <section className="detail-item">
          <section className="label">设备型号</section>
          <section className="text">{detail.modelName || '-'}</section>
        </section>
        <section className="detail-item">
          <section className="label">运营区域</section>
          <section className="text">{detail.areaName || '-'}</section>
        </section>
        <section className="detail-item">
          <section className="label">设备激活时间</section>
          <section className="text">{detail.activationTime || '-'}</section>
        </section>
        <section className="detail-item">
          <section className="label">服务开始时间</section>
          <section className="text">{detail.servicesStartTime || '-'}</section>
        </section>
        <section className="detail-item">
          <section className="label">服务结束时间</section>
          <section className="text">{detail.servicesEndTime || '-'}</section>
        </section>
      </section>
      <section className="detail-title">设备操作信息</section>
      <section>
        <Table
          dataSource={oprationList}
          rowKey="deviceId"
          columns={oprationColumns}
          pagination={false}
          scroll={{x: 'max-content', y: '400px'}}
         />
      </section>
      { messageContextHolder }
    </section>
  )
}